import UserDocumentsType from '@/app/arch/enums/UserDocumentsType';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import UploadService from '@/app/arch/services/UploadService';
import UsersRequest from '@/app/users/UsersRequest';

export default {
  mixins: [ServiceMixin],
  data: () => ({
    requestClass: UsersRequest,
    requestFile: UploadService,
    config: {
      errorMessage: 'Falha ao buscar imagens do cliente!',
      showSuccessSwal: false,
    },
    images: [],
    loading: false,
    maxSizeFiles: 1000,
    categories: UserDocumentsType,
  }),
  computed: {
    getClientId() {
      return this.analysisTable.client.id;
    },
    prepareRequest() {
      return (params = {}) => this.requestClass.getDocuments(
        this.makeParams({
          PerPage: this.maxSizeFiles,
          ClientId: this.getClientId,
          ...params,
        }),
      );
    },
    clientFiles() {
      return this.images.filter(
        (image) => image.documentType !== 'StoreFacade',
      );
    },
    companyFiles() {
      return this.images.filter(
        (image) => image.documentType === 'StoreFacade',
      );
    },
  },
  watch: {
    getClientId: {
      immediate: true,
      handler(id) {
        console.log(id);
        if (id && Number(id) >= 1) {
          this.getImages();
        }
      },
    },
    images: {},
  },
  methods: {
    getImages() {
      this.handleLoading();
      this.makeRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeRequest() {
      this.callService(
        this.prepareRequest(),
        this.config,
        this.prepareImagesResponse,
      );
    },
    prepareImagesResponse(response) {
      if (!this.hasData(response)) {
        this.handleLoading();
      } else if (this.isPaginated(response)) {
        this.getAllImages(response);
      } else {
        this.getDataFile(
          this.prepareData(
            response.data,
          ),
        );
      }
    },
    isPaginated(response) {
      return response.data.total > this.maxSizeFiles;
    },
    getAllImages(response) {
      this.callService(
        this.makePromisesRequest(response),
        this.config,
        this.prepareImagesResponse,
      );
    },
    makePromisesRequest(response) {
      return Promise.all(
        this.makePromisesArray(response.data.lastPage),
      ).then(
        this.makeOneListResponse(
          this.prepareData(response.data),
        ),
      );
    },
    makePromisesArray(lastPage) {
      const promises = [];
      for (let page = 2; page <= lastPage; page += 1) {
        promises.push(
          this.prepareRequest({
            Page: page,
          }),
        );
      }
      return promises;
    },
    makeOneListResponse(firstDocuments = []) {
      return (responses = []) => ({
        data: {
          data: [
            ...firstDocuments,
            ...responses.reduce(
              this.joinOnlyOneArray(),
              [],
            ),
          ],
          total: this.maxSizeFiles,
        },
      });
    },
    joinOnlyOneArray() {
      return (acc, crr) => {
        if (Array.isArray(acc)) {
          acc.forEach(
            (item) => crr.push(item),
          );
        } else {
          crr.push(acc);
        }

        return crr;
      };
    },
    getDataFile(files = []) {
      this.callService(
        this.makePromisesFileRequest(files),
        this.config,
        this.setDataImages(files),
      );
    },
    makePromisesFileRequest(files = []) {
      return Promise.all(
        this.prepareFileRequest(files.map(
          (file) => file.fileName,
        )),
      ).then(
        (responses) => ({
          data: responses.map(
            (response) => response.data,
          ),
        }),
      );
    },
    prepareFileRequest(fileNames = []) {
      const promises = [];
      fileNames.forEach(
        (fileName) => promises.push(
          this.requestFile.get(fileName),
        ),
      );
      return promises;
    },
    setDataImages(documents = []) {
      return (response) => {
        this.handleLoading();
        if (this.hasData(response)) {
          this.images = documents.map(
            (document, pos) => ({
              category: this.getDocumentType(document.documentType),
              url: response.data[pos],
              documentType: this.documentType,
            }),
          );
        }
      };
    },
    getDocumentType(documentType) {
      const type = this.categories.find(
        (category) => category.value === documentType,
      );
      if (type) {
        return type.text;
      }
      return documentType;
    },
  },
  inject: {
    analysisTable: {
      default() {
        return {
          client: {
            id: '',
          },
        };
      },
    },
  },
};
